import type { FC } from 'react';
import { Link } from 'react-router-dom';

const Footer: FC = () => {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-sound-module-line text-2xl text-accent-400"></i>
              </div>
              <span className="font-heading text-lg font-semibold tracking-wide whitespace-nowrap">ASMR基佬中心</span>
            </div>
            <p className="text-sm text-foreground-200 leading-relaxed">
              专为ASMR爱好者打造的内容聚合社区，汇聚海量ASMR音频视频资源，提供放松助眠、情感陪伴类ASMR内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">首页</Link></li>
              <li><Link to="/category/shuimian-fangsong" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/shuimian-fangsong" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">助眠放松</Link></li>
              <li><Link to="/category/eryu-peiban" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">耳语陪伴</Link></li>
              <li><Link to="/category/chufa-yinxiao" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">触发音效</Link></li>
              <li><Link to="/category/baizaoyin" className="text-sm text-foreground-200 hover:text-accent-400 transition-colors duration-200">环境白噪音</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-200">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-accent-400"></i>
                </div>
                hello@asmr-geek-center.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-200">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line text-accent-400"></i>
                </div>
                ASMRGeekCenter
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-200/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-300">© 2026 ASMR基佬中心 版权所有 | 专注ASMR内容聚合与社区建设</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-300 hover:text-accent-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-300 hover:text-accent-400 transition-colors duration-200" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;